import 'babel-polyfill'
import App from './pages/App'
import router from './router'
import store from './vuex/store'
import { sync } from 'vuex-router-sync'
import './custom/filters'
import './custom/directives'

// keep vue-router and vuex store in sync
sync(store, router)

// start router
router.start(App, '#app')



// WEBPACK FOOTER //
// ./src/main.js